import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faEdit } from "@fortawesome/free-solid-svg-icons";
import { PopupConfirm, TextInput } from "../indexComponents";
import moment from "moment";
import "moment/locale/fr-ca"; // Importez la localisation française si nécessaire

function ClientsData({
  clients,
  onDeleteClient,
  onSelectedClientsChange,
  onClientAdded,
  isTeam,
}) {
  const [search, setSearch] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isPopupDisplayed, setIsPopupDisplayed] = useState(false);
  const [clientToDelete, setClientToDelete] = useState([]);
  const [customsFields, setCustomsFields] = useState([]);
  const [isClientBeingEdited, setIsClientBeingEdited] = useState(false);
  const [clientToEdit, setClientToEdit] = useState([]);
  const [shouldSubmit, setShouldSubmit] = useState(false);
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [company, setCompany] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [e, setE] = useState();
  const [website, setWebsite] = useState("");

  useEffect(() => {
    setFiltered(clients);
  }, [clients]);

  useEffect(() => {
    if (search) {
      const result = clients.filter((client) =>
        client.name.toLowerCase().includes(search.toLowerCase())
      );
      setFiltered(result);
    } else {
      setFiltered(clients);
    }
  }, [search, clients]);

  const ExpandedComponent = ({ data }) => (
    <div className="dropdown-client-container">
      <h3>Détails du client</h3>
      <div className="info-1">
        {data.name ? (
          <p>
            <b>Nom :</b> {data.name}
          </p>
        ) : (
          ""
        )}
        {data.company ? (
          <p>
            <b>Entreprise :</b> {data.company}
          </p>
        ) : (
          ""
        )}
      </div>
      <div className="info-1">
        {data.email ? (
          <p>
            <b>Email :</b> <a href={`mailto:${data.email}`}>{data.email}</a>
          </p>
        ) : (
          ""
        )}
        {data.phoneNumber ? (
          <p>
            <b>Téléphone :</b>{" "}
            <a href={`tel:${data.phoneNumber}`}>{data.phoneNumber}</a>
          </p>
        ) : (
          ""
        )}
        {data.website ? (
          <p>
            <b>Site Web :</b>
            <a href={`${data.website}`}>{data.website}</a>
          </p>
        ) : (
          ""
        )}
      </div>
      {data.createdAt ? (
        <p>
          <b>Ajouté :</b> {moment(data.createdAt).fromNow()}
        </p>
      ) : (
        ""
      )}
      {data.updatedAt ? (
        <p>
          <b>Dernière modification :</b> {moment(data.updatedAt).fromNow()}
        </p>
      ) : (
        ""
      )}
    </div>
  );

  const CustomFieldsCell = ({ row }) => {
    const { customs_fields } = row;

    if (!customs_fields) {
      return null;
    }

    return (
      <div className="custom-field-container">
        {customs_fields.map((field, index) => (
          <label key={field.id} className="control control-checkbox">
            <input
              type="checkbox"
              checked={field.completed}
              onChange={(e) => {
                handleCheckboxChange(index, e.target.checked, e, row);
              }}
              className="checkbox"
            />
            {field.custom_field}
            <div className="control_indicator"></div>
          </label>
        ))}
      </div>
    );
  };

  // Sauvegarder les changements
  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/client/${clientToEdit.id}/${isTeam}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          name,
          email,
          company,
          phoneNumber,
          customs_fields: customsFields,
          website,
        }),
      }
    );

    if (response.ok) {
      onClientAdded();
      setIsClientBeingEdited(false);
      setClientToEdit([]);
      setCustomsFields([]);
      setE();
    } else {
      console.error("Erreur lors de l'ajout du client");
    }
  };

  useEffect(() => {
    if (shouldSubmit && clientToEdit) {
      handleSubmit(e);
      setShouldSubmit(false);
    }
  }, [shouldSubmit, clientToEdit]);

  const handleCheckboxChange = (index, isChecked, e, client) => {
    setClientInfo(client);
    setE(e);
    let updatedFields = [...client.customs_fields];
    updatedFields[index].completed = isChecked;
    setCustomsFields(updatedFields);
    setShouldSubmit(true);

    // Add a CSS class to the clicked checkbox indicator
    const checkboxIndicator = e.target;
    checkboxIndicator.classList.add("input-animation");

    // Remove the CSS class after the animation completes
    setTimeout(() => {
      checkboxIndicator.classList.remove("input-animation");
    }, 1000);
  };

  const columns = [
    {
      name: "Nom",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Entreprise",
      selector: (row) => row.company,
      sortable: true,
    },
    {
      name: "Courriel",
      selector: (row) => row.email,
      sortable: true,
    },
    /*         {
            name: 'Téléphone',
            selector: row => row.phoneNumber,
            sortable: true,
        }, */
    {
      name: "Champs",
      cell: (row) => <CustomFieldsCell row={row} />,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="action-btn-container">
          <button
            onClick={() => {
              setIsClientBeingEdited(true);
              setClientInfo(row);
            }}
            className="btn-edit-client"
          >
            <FontAwesomeIcon icon={faEdit} />
          </button>
          <button
            onClick={(e) => {
              setClientToDelete(row);
              setIsPopupDisplayed(true);
            }}
            className="btn-delete-client"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
      ),
    },
  ];

  // Est appellé chque fois qu'on clique sur un bouton d'un client ou qu'on coche un customs_fields
  const setClientInfo = (client) => {
    setClientToEdit(client);
    setName(client.name);
    setEmail(client.email);
    setCompany(client.company);
    setPhoneNumber(client.phoneNumber);
    setCustomsFields(client.customs_fields);
  };

  return (
    <div className="table">
      {isClientBeingEdited ? (
        <div className="edit-client-container">
          <form className="clientForm">
            <div className="row">
              <TextInput
                labelText="Nom du client"
                name="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <TextInput
                labelText="Email du client"
                name="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="row">
              <TextInput
                labelText="Compagnie du client :"
                name="company"
                type="text"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
              />
              <TextInput
                labelText="Numéro de téléphone du client :"
                name="phoneNumber"
                type="tel"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </div>
            <TextInput
              labelText="Site web du client :"
              name="website"
              type="text"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />
            <div>
              <button className="save-change-btn" onClick={handleSubmit}>
                Sauvegarder
              </button>
              <button
                className="cancel-change-btn"
                onClick={() => {
                  setIsClientBeingEdited(false);
                }}
              >
                Annuler
              </button>
            </div>
          </form>
        </div>
      ) : (
        ""
      )}
      <DataTable
        columns={columns}
        data={filtered}
        selectableRows
        onSelectedRowsChange={({ selectedRows }) => {
          setSelectedRows(selectedRows.map((row) => row.id));
          onSelectedClientsChange(selectedRows.map((row) => row.id));
        }}
        expandableRows
        expandableRowsComponent={ExpandedComponent}
        pagination
        fixedHeader
        fixedHeaderScrollHeight="600px"
        subHeader
        subHeaderComponent={
          <input
            type="text"
            placeholder="Recherche"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        }
      />
      {isPopupDisplayed ? (
        <PopupConfirm
          text={`Voulez-vous vraiment supprimer ${clientToDelete.name}?`}
          textBtnConfirm="Supprimer"
          textBtnCancel="Annuler"
          onClickConfirm={() => {
            onDeleteClient(clientToDelete.id);
            setIsPopupDisplayed(false);
          }}
          onClickCancel={() => setIsPopupDisplayed(false)}
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default ClientsData;
